module.exports = __webpack_public_path__ + "img/logo-6-light.e49742fa.png";